import React from 'react';
import { Building2 } from 'lucide-react';

const ContactStep = ({ contact, updateContact, nextStep, prevStep }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    nextStep();
  };

  return (
    <form onSubmit={handleSubmit} className="form-step" data-testid="contact-step">
      <h2 className="step-title">Your Information</h2>
      <p className="step-description">How can we reach you about this booking?</p>

      <div className="form-group">
        <label className="form-label">Full Name</label>
        <input
          type="text"
          className="form-input"
          value={contact.name}
          onChange={(e) => updateContact({ name: e.target.value })}
          placeholder="John Doe"
          required
          data-testid="contact-name-input"
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-input"
            value={contact.email}
            onChange={(e) => updateContact({ email: e.target.value })}
            placeholder="john@example.com"
            required
            data-testid="contact-email-input"
          />
        </div>
        <div className="form-group">
          <label className="form-label">Phone</label>
          <input
            type="tel"
            className="form-input"
            value={contact.phone}
            onChange={(e) => updateContact({ phone: e.target.value })}
            placeholder="(555) 123-4567"
            required
            data-testid="contact-phone-input"
          />
        </div>
      </div>

      <div
        className={`pm-toggle ${contact.is_property_manager ? 'selected' : ''}`}
        onClick={() => updateContact({ is_property_manager: !contact.is_property_manager })}
        data-testid="pm-toggle"
      >
        <div className="pm-toggle-icon"><Building2 size={20} strokeWidth={1.5} /></div>
        <div className="pm-toggle-info">
          <span className="pm-toggle-title">I'm a property manager</span>
          <span className="pm-toggle-desc">Book cleanings for multiple properties in one checkout</span>
        </div>
        <div className={`pm-toggle-switch ${contact.is_property_manager ? 'on' : ''}`}>
          <div className="pm-toggle-knob" />
        </div>
      </div>

      {contact.is_property_manager && (
        <div className="form-group">
          <label className="form-label">Company Name <span className="form-optional">(optional)</span></label>
          <input
            type="text"
            className="form-input"
            value={contact.company}
            onChange={(e) => updateContact({ company: e.target.value })}
            placeholder="Your management company"
            data-testid="contact-company-input"
          />
        </div>
      )}

      <div className="form-group">
        <label className="form-label">Access Details <span className="form-optional">(optional)</span></label>
        <textarea
          className="form-input form-textarea"
          value={contact.access_notes}
          onChange={(e) => updateContact({ access_notes: e.target.value })}
          placeholder="Gate codes, lockbox, parking, pets, or other entry instructions..."
          rows={3}
          data-testid="access-notes-input"
        />
      </div>

      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={prevStep} data-testid="contact-step-back">
          Back
        </button>
        <button type="submit" className="btn btn-primary" data-testid="contact-step-next">
          Review Booking
        </button>
      </div>
    </form>
  );
};

export default ContactStep;
